<template>
  <div class="agreement">
    <div class="title">
        <van-icon name="arrow-left" class="close" @click="close"/>
        交易出售协议
    </div>
    <div class="content">
        <div class="box">
            <p class="indent">交易平台所有游戏小程序的角色和账号不支持交易，小程序升级的账号也不支持交易。小程序用户仍发布商品的，保证金提现费用需自行承担。</p>
            <p>1、首先，在平台注册的账号必须进行实名认证方可出售。</p>
            <p>2、挂售信息尽量填写完整，如装备、以及高价值道具可明确标出，提高出售成功率。</p>
            <p>3、挂售角色后需要主动联系客服进行审核，审核通过后，需封停角色，以保证装备等物品道具齐全。在封停角色后由系统上架出售。</p>
            <p>4、卖家需提供客服要求的对应角色信息进行验证，验证后客服进行截图上架</p>
            <p>5、挂售账号需缴商品标价累计金额对应档位的保证金，交易完成后，无挂售中、审核中、交易中的商品，现有保证金可进行提现。提现1-7个工作日内到账。出现以下两种情况，保证金则不退还：</p>
            <p>（1）账号挂售后，买家已成功付款，此时卖家取消订单，则不退还账号标价对应的保证金。</p>
            <p>（2）账号挂售后，有其它玩家找回账号，并且确认的情况下，取消挂售并且不退还账号标价对应的保证金。</p>
            <p>（3）卖家发布商品的价格不能与商品价值差异过大，如差异过大平台将判定该商品异常驳回挂售。</p>
            <p>（4）如商品成功上架后，卖家修改商品价格与商品价值差异过大，并且有买家成功付款。平台将判定该笔订单异常并取消订单，并由卖家承担买家提现手续费以及扣除卖家对应金额的保证金。</p>
            <p class="indent">以上情况同意后，挂售后，由平台客服登陆游戏角色核实道具等情况，届时如果玩家强登则交易取消。平台客服核实道具后封停角色。</p>
            <p class="indent">由于挂售流程较为繁琐，成功上架后至少需要3日才可以申请提前下架，请勿随意下架，下架后，7个工作日后才可重新审核上架。</p>
            <p class="indent">寄售以及担保的账号，到时间自动下架后需要卖家主动联系客服申请继续上架或者下架解封。</p>
            <p>注：如挂售成功，所有用户均可购买，无法指定购买。如交易成功，即该商品出售成功，该笔交易无法取消。出售的仅为角色，如要出售账号下的多个角色，需备注说明。出售成功后，账号依然可正常登陆，但游戏角色将会被转移至买家账号。</p>
            <p class="indent">出售整个账号的，该账号下所有角色包含该账号下其他游戏的角色一并出售。出售成功后，账号会更改成买家账号，绑定信息也会进行换绑处理，卖家无法进行登录。</p>
            <p class="indent">为了向各位用户提供更安全优质的服务，G买卖交易平台会根据用户的交易金额，收取一定的服务费用，我们所收取的费用，将用于为广大用户建设全方位的安全手游交易环境，保证专业客户服务，让用户在这里享受到更愉快的交易体验。安全、负责、高效、专业、贴心，这是您在其他网站难以享受到的。同时如果部分收费标准有变动，我们将在首页公告，请您关注！ </p>
            <br/>
            <p>账号交易收费标准：</p>
            <p class="indent">角色交易向卖家收取每笔成交金额的10%，最低为10元人民币。 </p>
            <p>注：帐号交易服务费由卖家承担， 卖家帐号出售成功以后，直接从卖家货款中扣除交易费用。所有从交易平台提现的金额均需收取提现手续费。（包含保证金提现，余额提现等）</p>
            <p class="indent">提现时余额收取1%的提现手续费，最低2元，小数点向上取整。保证金提现收取2%的提现手续费。</p>
        </div>
        <van-button color="var(--theme)" round class="agree_btn" @click="agree">同意协议并继续</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    close() {
        this.$emit('handleClose')
    },
    agree() {
        this.$store.commit("changeBuyAgree",1)
        this.$emit('handleSuccess')
    }
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.agreement {
    height: calc(var(--vh,1vh)*100);
    background-color: var(--innerbgc);
    display: flex;
    flex-direction: column;
    .title {
        height: 5rem;
        line-height: 5rem;
        text-align: center;
        background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        // background: linear-gradient( 180deg, #FE4B1E 0%, #FF636F 100%);
        color: #fff;
        font-size: 1.7rem;
        position: relative;
        .close {
            position: absolute;
            top: 50%;
            left: 1.8rem;
            transform: translateY(-50%);
            color: #fff;
            font-size: 1.8rem;
            cursor: pointer;
        }
    }
    .content {
        flex: 1;
        padding: 1.5rem 1rem;
        overflow-y: auto;
        .box {
            padding: 1.5rem 1rem;
            background-color: #fff;
            border-radius: 1rem;
            font-size: 1.4rem;
            color: #555;
            line-height: 1.8;
            h3 {
                font-size: 1.6rem;
                font-weight: normal;
                margin: 1.2rem 0;
            }
            .indent {
                text-indent: 2.8rem;
            }
        }
    }
    .agree_btn {
        display: block;
        width: 33.5rem;
        height: 5rem;
        margin: 1.5rem auto 2rem;
        font-size: 1.6rem;
    }
}
@media screen and (min-width: 525px) {
    .agreement {
        .title {
            .close {
                left: 2rem;
            }
        }
    }
}
</style>
